/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'shared';
const componentName = 'backup-passphrase';
const prefix = `${moduleName}.${componentName}`;

export const passphraseLabel = `${prefix}.passphraseLabel`;
export const passphrasePlaceholder = `${prefix}.passphrasePlaceholder`;
export const confirmPassphraseLabel = `${prefix}.confirmPassphraseLabel`;
export const confirmPassphrasePlaceholder = `${prefix}.confirmPassphrasePlaceholder`;
export const passphraseMismatchError = `${prefix}.passphraseMismatchError`;

export const ENGLISH = {
    [passphraseLabel]: 'Passphrase',
    [passphrasePlaceholder]: 'Enter Passphrase',
    [confirmPassphraseLabel]: 'Confirm Passphrase',
    [confirmPassphrasePlaceholder]: 'Enter Confirm Passphrase',
    [passphraseMismatchError]: 'Passphrase does not match',
};
